import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import axios from "axios";

export default function(state = initialState.settings, action) {
  switch (action.type) {
      case ActionTypes.GET_ACTIVE_SETTINGS + ActionTypes.FULFILLED:
          //let newSettings = action.payload.data;
          //let settings = new Settings("�", 12, 0, 0, "img/account/default-user-ava.png", "dd/MM/yyyy");

          //if (newSettings && newSettings.noShop === true) {
          //    return 
          //}
          let settings = { ...action.payload.data, catalogueUrl: '' };
          if (settings.googleAutocompleteAddressFormat) {
              settings.googleAutocompleteAddressFormat =  JSON.parse(settings.googleAutocompleteAddressFormat);
          }
          return settings;
      case ActionTypes.LOGIN + ActionTypes.FULFILLED:
          let { newBaseUrl, representative } = action.payload.data;
          if (newBaseUrl) {
              state = { ...state, baseUrl: newBaseUrl, isPersonalisedSite: true, shopName: representative.shopName };
              axios.defaults.headers.common['shopName'] =  representative.shopName;
          }
          return state;
    default:
      return state;
  }
}
